<template>
  <v-navigation-drawer v-model="showSearchMenu" mobile-break-point="0">
    <v-list>
      <v-list-item @click="navigateTo('division', 1)">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.Distribution") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item @click="navigateTo('division', 2)">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.Transport") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="navigateTo('division', 3)">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.AirOcean") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item @click="navigateTo('division', 4)">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.Logistics") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item @click="navigateTo('division', 5)">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.SpecialServices") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item @click="navigateTo('quotations')">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.Quotazioni") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="navigateTo('communications')">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.Comunicazioni") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="navigateTo('admin')" v-if="!isMobile && showAdminMenu">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("Menu.Admin") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="logout-div">
      <span @click="logout()">{{ $t("Misc.logout") }}</span>
    </div>
  </v-navigation-drawer>
</template>
<style>
aside {
  width: 348px !important;
  position: absolute;
  z-index: 1000;
}

.v-navigation-drawer {
  top: 40px !important;
}

.v-navigation-drawer__content {
  padding: 0px;
}

.v-navigation-drawer__content .v-list {
  padding: 0px !important;
}

.v-navigation-drawer__content .v-list-item {
  padding: 0 36px 0 36px;
  height: 65px;
  border: 1px solid rgb(112, 112, 112, 0.46);
}

.logout-div {
  color: white;
  font-size: 30px;
  font: normal normal bold 30px/64px Roboto;
}

.logout-div span {
  margin-left: 36px;
}

.v-navigation-drawer__content .v-list-item .v-list-item__title {
  color: #5d6367;
  font-size: 30px;
  font: normal normal bold 30px/64px Roboto;
}

.v-navigation-drawer__content .v-list-item .v-list-item__content {
  padding: 0px;
}

.logout-div {
  display: none;
}

@media (min-width: 600px) {
  aside {
    z-index: 4;
  }

  aside .v-navigation-drawer__content {
    padding-top: 100px;
  }
}

@media (max-width: 600px) {
  aside {
    width: 100% !important;
    z-index: 4;
    position: fixed;
  }

  aside .v-navigation-drawer__content {
    padding-top: 71px;
  }

  .logout-div {
    display: block;
    background-color: #6f767a !important;
    height: 71px;
    position: fixed;
    width: 100%;
    bottom: 0px;
  }
}

.v-navigation-drawer__content .container,
.v-navigation-drawer__content .row {
  height: 100%;
}

.v-navigation-drawer__content .container,
.v-navigation-drawer__content .col {
  padding: 0px !important;
}
</style>
<script>
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import GAApi from "../api/GA/GAApi.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";

export default {
  components: {},

  props: {
    showSearchMenu: Boolean,
  },

  data: (vm) => ({
    load: false,
    isMobile: false,
    showAdminMenu: false,
  }),

  watch: {},

  mounted() { },

  async created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();

    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      //console.log("username refresh: ", this.$GAUserAuth.user.username);

      var user = this.$GAUserAuth.user;
      //   console.log("user", user);
      MyFercamApi.IsAdmin(user.username).then((data) => {
        // console.log("data: ", data);
        this.showAdminMenu = data.data;
      });
    });
  },

  methods: {
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    logout() {
      sessionStorage.removeItem("GlobalAuthUser");

      var res = $cookies.remove(
        "GlobalAuthUser",
        null,
        this.$genericClass.GetCurrentDomain()
      );

      var hostName = window.location.hostname;
      var logout_url =
        this.$genericClass.GetSSOUrl() + "/home/logout?r=" + btoa(hostName);
      //   console.log("logout url", logout_url);
      location.href = logout_url;
    },
    async navigateTo(component, divisionId) {
      if (divisionId) {
        let userId = this.$GAUserAuth.user.id;
        let res = await GAApi.GetApplications(userId, divisionId);
          console.log("app res:", res.data);
        this.applications = res.data;

        if (this.applications.length == 0) {
          router
            .push({
              name: "quotations",
              params: { DivisionId: divisionId },
            })
            .catch((err) => {
              this.close();
            });
          return;
        } else {
          router
            .push({ name: component, params: { DivisionId: divisionId } })
            .catch((err) => {
              this.close();
            });
        }

        //   console.log("apps:", this.applications);

      } else {
        router
          .push({ name: component, params: { DivisionId: divisionId } })
          .catch((err) => {
            this.close();
            // to avoid refreshing page force default communications page behaviour
            this.$store.commit(
              "SET_refreshCommunications",
              !this.$store.getters.GET_refreshCommunications
            );
          });
      }
    },
    close() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
  },
};
</script>